import * as React from "react";
import styled from "styled-components";
import { formatDate, parseISO } from "date-fns";
import { Page } from "src/components/Page";
import { BudgetTab } from "./BudgetTab";
import { DateNav } from "src/components/DateNav";
import { useQueryParam } from "src/hooks/useQueryParam";
import { TransactionsTab } from "./TransactionsTab";
import { Tabs } from "src/components/Tabs";

export function Transactions() {
  const [categoryId, handleSetCategoryId] = useQueryParam("categoryId");
  const [tab, setTab] = React.useState("budget");
  const [qsMonth, setMonth] = useQueryParam("month");

  const month = qsMonth ?? formatDate(new Date(), "yyyy-MM");
  const date = parseISO(month + "-01");

  const setDate = (date: Date) => {
    setMonth(formatDate(date, "yyyy-MM"));
  };

  const setCategoryId = (categoryId: string | null) => {
    handleSetCategoryId(categoryId);
    setTab("transactions");
  };

  const tabs = React.useMemo(() => {
    return [
      {
        id: "transactions",
        label: "Transactions",
        render: () => <TransactionsTab {...{ month, categoryId, setCategoryId }} />,
      },
      {
        id: "budget",
        label: "Budget",
        render: () => <BudgetTab {...{ month, setCategoryId }} />,
      },
    ];
  }, [month, categoryId, setCategoryId]);

  return (
    <Page>
      <DateHeader>
        <DateNav mode="month" date={date} setDate={setDate} />
      </DateHeader>
      <Tabs selected={tab} onSelect={setTab} tabs={tabs} />
    </Page>
  );
}

const DateHeader = styled.div`
  margin-bottom: 20px;
`;
